import type { Copy } from "../lib/copy";

type FooterProps = { t: Copy };

export function Footer({ t }: FooterProps) {
  // Footer is always on a dark background — always use the light (white) logo.
  const logoSrc = "/assets/logo-light.png";
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="foot-brand">
            <img src={logoSrc} alt="Stratex-AI" className="foot-logo" />
            <p>{t.footer.tagline}</p>
          </div>
          {t.footer.cols.map((c, i) => (
            <div key={i} className="foot-col">
              <div className="foot-title">{c.title}</div>
              <ul>
                {c.items.map((it, j) => (
                  <li key={j}>
                    <a href="#">{it}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="foot-bottom">
          <span>{t.footer.copy}</span>
          <span className="foot-status">
            <span className="pulse small" /> All systems operational
          </span>
        </div>
      </div>
    </footer>
  );
}
